<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical headerTitle="91.3 Delivery Status" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnExcel'
                ]" @btnRetrieve="btnRetrieve()" @btnExcel="onExporting()" >
                    <template v-slot:body>
                        <v-layout column overflow-auto>
                            <v-row dense>
                                <v-col cols="12" class="pa-0">
                                    <i-card-top class="d-md-flex" outlined >
                                        <template v-slot:body>
                                            <v-layout column>
                                                <v-row no-gutters class="center pa-2 pb-2">
                                                    <v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Ship no : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedShip" :items="shipNoList"
                                                            item-value="selectedShip" label="" return-object single-line
                                                            outlined dense @change="shipNoChange"></v-select>
                                                    </v-col>
                                                    <v-btn class="mx-sm-2" small color="primary" @click="goGINR()"> GINR </v-btn>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Por no : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedPor" :items="porList" item-value="selectedPor" return-object single-line 
                                                            outlined dense :label="'All'" 
                                                            @change="btnRetrieve()"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Block : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedBlock" :items="blockList"
                                                            item-value="selectedBlock" return-object single-line
                                                            outlined dense :label="'All'"
                                                            @change="btnRetrieve()"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Make Status : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="makeSta.select" :items="makeSta.items" item-text="name" item-value="cd" return-object
                                                            single-line outlined dense />
                                                    </v-col>
                                                    <v-icon v-show="vMaker" small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span v-show="vMaker" class="pa-1 subTitle"> Make Location : </span>
                                                    <v-col v-show="vMaker" cols="1">
                                                        <v-select v-model="makeLoc.select" :items="makeLoc.items" item-text="name" item-value="cd" return-object single-line
                                                            outlined dense />
                                                    </v-col>
                                                </v-row>
                                                <v-row  dense class="ma-0">
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 pt-2 subTitle">Duration Div : </span>
                                                    <v-col cols="2">
                                                        <v-select v-model="durDiv.select" :items="durDiv.items" item-text="name" item-value="cd" return-object single-line
                                                            outlined dense />
                                                    </v-col>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="startDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                                                    </v-col>
                                                    <span class="pa-1 pt-2 subTitle"> ~ </span>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="endDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }" />
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <DxDataGrid id="epms9060" class="listBox" :ref="epms9060Ref"
                                        :data-source="gridMainList" :remote-operations="false"
                                        :hover-state-enabled="true" :allow-column-resizing="true"
                                        :allow-column-reordering="true" :row-alternation-enabled="true"
                                        :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                                        :focused-row-enabled="true" :column-hiding-enabled="false"
                                        :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                        :word-wrap-enabled="true"
                                        @cellPrepared="cellPrepared" data-row-template="dataRowTemplate"  >
                                        
                                        <DxColumn data-field="no" caption="No" width="5%" data-type="string"
                                            :allow-editing="false" alignment="center"/>
                        
                                        <DxColumn caption="Ship No" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn data-field="shipNo" caption="Por No" width="10%" data-type="string"
                                                :allow-editing="false" alignment="center" :visible="true" />                                            
                                        </DxColumn>

                                        <DxColumn caption="Block" width="8%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="block" caption="Part No" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>
<!-- 
                                        <DxColumn caption="Lot No" width="10%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" /> -->
                                        
                                        <DxColumn caption="Activity" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="mAct" caption="Ser" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Unit" width="5%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="matlUnit" caption="Part Specification" width="5%" data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="BOM Qty" width="7%" data-type="string" :allow-editing="false" alignment="center" :visible="true" header-cell-template = "BOM">
                                            <DxColumn data-field="partQty" caption="Part Specification" width="7%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>
                                        <template #BOM><div>BOM<br/>Qty</div></template>
                                        <DxColumn caption="Unit Weight" width="8%" data-type="string" :allow-editing="false" alignment="center" :visible="true" header-cell-template = "uWgt">
                                            <DxColumn data-field="partUnitWgt" caption="Part Specification" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>
                                        <template #uWgt>
                                            <div>Unit<br />Weight</div>
                                        </template>
                                        <DxColumn caption="W/H Qty" width="8%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="whQty" caption="Not WH Qty" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" header-cell-template="notWhQty"/>
                                        </DxColumn>
                                        <template #notWhQty>
                                            <div>Not W/H<br />Qty</div>
                                        </template>

                                        <DxColumn data-field="mDiv" caption="Stage" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                        
                                        <DxColumn caption="Make Loc" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="makeLoc" caption="Pain Loc" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="W/H Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="whDte" caption="Keep Loc" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Req.Iss. Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" header-cell-template="reqIssDte">
                                            <DxColumn data-field="reqIssDte" caption="Issue Date" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <template #reqIssDte>
                                            <div>Req.Iss.<br />Date</div>
                                        </template>

                                        <DxColumn caption="Material Need Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" header-cell-template="matlNeedDte">
                                            <DxColumn data-field="psdDt" caption="POR Date" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <template #matlNeedDte>
                                            <div>Material<br />Need Date</div>
                                        </template>

                                        <DxColumn caption="IN(S.F.P)" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" header-cell-template="inProc">
                                            <DxColumn data-field="pipeInproc" caption="OUT(S.F.P)" width="7%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" header-cell-template="outProc"/>
                                        </DxColumn>
                                        
                                        <template #inProc>
                                            <div>IN<br />(S.F.P)</div>
                                        </template>

                                        <template #outProc>
                                            <div>OUT<br />(S.F.P)</div>
                                        </template>
                                        
                                        <template #delPlnDte>
                                            <div>Delivery<br />Plan Date</div>
                                        </template>

                                        <DxColumn caption="IN(P)" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" >
                                            <DxColumn data-field="pipeInpaint" caption="OUT(P)" width="7%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn data-field="press" caption="S.Test" width="7%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        <DxColumn data-field="cls" caption="Class" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" />

                                        <DxColumn caption="Make Start" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="stMakeDte" caption="Fab Finish" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Paint Start" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="stPaintDte" caption="Paint Finish" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Quot No" width="10%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true">
                                            <DxColumn data-field="quotNo" caption="Delivery No" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="POR Request Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" header-cell-template="porReqDte">
                                            <DxColumn data-field="reqDte" caption="Delivery Plan Date" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" header-cell-template="deliPlnDte"/>
                                        </DxColumn>
                                        
                                        <template #porReqDte>
                                            <div>POR<br />Request<br /> Date</div>
                                        </template>

                                        <template #deliPlnDte>
                                            <div>Delivery<br />Plan Date</div>
                                        </template>

                                        <DxColumn data-field="reqEmp" caption="Requester" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" />
                                        
                                        <template #dataRowTemplate="{data: rowInfo }">
                                            <fragment>
                                                <tr class="main-row">
                                                    <td rowspan="2" style="text-align:center">{{ rowInfo.data.rnum }}</td>
                                                    <td style="text-align:center">{{  rowInfo.data.shipNo }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.block }}</td>
                                                    <!-- <td style="text-align:center">{{ rowInfo.data.matlGrp }}</td> -->
                                                    <td style="text-align:center">{{ rowInfo.data.mact }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.matlUnit }}</td>
                                                    <td style="text-align:center; background-color: #B6D3F0;">{{ rowInfo.data.partQty }}</td>
                                                    <td style="text-align:right">{{ formatPrice(rowInfo.data.partUnitWgt) }}</td>
                                                    <td style="text-align:center; background-color: #C6D3A0;">{{ rowInfo.data.whQty }}</td>
                                                    <td style="text-align:right" rowspan="2">{{ rowInfo.data.mdiv }}</td>
                                                    <td style="text-align:center; background-color: #C6F3F0;">{{ rowInfo.data.makeLoc }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.whDte }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.reqIssDte }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.psdDt }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.pipeInproc }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.pipeInpaint }}</td>
                                                    <td rowspan="2" style="text-align:center">{{ rowInfo.data.press }}</td>
                                                    <td rowspan="2" style="text-align:center">{{ rowInfo.data.cls }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.stMakeDte }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.stPaintDte}}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.quotNo }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.reqDte }}</td>
                                                    <td rowspan="2" style="text-align:center">{{ rowInfo.data.reqEmp }}</td>
                                                </tr>
                                                <tr class="notes-row">
                                                    <td style="text-align:center">
                                                        <v-btn ref="thePorBtn" x-small elevation="0" color="transparent" class="px-0 py-0 grd-btn" @click.stop="drawingPage($event)">
                                                            {{ rowInfo.data.porNo }}
                                                        </v-btn><br/>
                                                        {{ '-' + rowInfo.data.porSeq }}
                                                    </td>
                                                    <td style="text-align:center">{{ rowInfo.data.partNo }}</td>
                                                    <!-- <td style="text-align:center">{{ rowInfo.data.matlGrpNm }}</td> -->
                                                    <td style="text-align:center">{{ rowInfo.data.bomSerno }}</td>
                                                    <td colspan="3" style="text-align:left">{{ rowInfo.data.partSpec }}</td>
                                                    <td style="text-align:center; background-color: #C6A3A0;">{{ rowInfo.data.nyQty }}</td>
                                                    <td style="text-align:center; background-color: #C6F3F0;">{{ rowInfo.data.locNop }}</td>
                                                    <td style="text-align:center; background-color: #C6F3F0;">{{ rowInfo.data.delyLoc }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.issDte }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.porDt }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.pipeOutproc }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.pipeOutpaint }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.edMakeDte }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.edPaintDte }}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.delyNo}}</td>
                                                    <td style="text-align:center">{{ rowInfo.data.delyPlanDte }}</td>
                                                </tr>
                                            </fragment>
                                        
                                        </template>

                                        <DxPaging :enabled="true" :page-size="30" />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>

                            <v-row no-gutters >
                                <v-col cols="12" class="pa-0">
                                    <DxDataGrid id="epms9060Excl" class="listBox" :ref="epms9060ExclRef"
                                        :data-source="gridMainList" :remote-operations="false"
                                        :hover-state-enabled="true" :allow-column-resizing="true"
                                        :row-alternation-enabled="true"
                                        :columnAutoWidth = "true" :useNative = "true"
                                        :show-borders="true" width="200%" :show-row-lines="true" key-expr="id"
                                        :focused-row-enabled="true" :column-hiding-enabled="false"
                                        :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                        :word-wrap-enabled="false"                                                                               
                                        @exporting="onExporting">
                                        <DxExport :enabled="true" />
                                        <DxColumn data-field="rnum" caption="No" width="5%" data-type="string"
                                            :allow-editing="false" alignment="center"/>
                        
                                        <DxColumn data-field="shipNo" caption="Ship No" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true"/>                                                                                   
                                        
                                        <DxColumn data-field="porNo" caption="Por No" width="10%" data-type="string"
                                                :allow-editing="false" alignment="center" :visible="true" />     
                                        
                                        <DxColumn data-field="porSeq" caption="Por Seq" width="5%" data-type="string"
                                        :allow-editing="false" alignment="center" :visible="true" />     

                                        <DxColumn data-field="block" caption="Block" width="8%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="matlGrp" caption="Lot No" width="8%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" /> 
                                        
                                        <DxColumn data-field="lotNm" caption="Lot Name" width="8%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" /> 
                                        
                                        <DxColumn data-field="mDiv" caption="Stage" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="partNo" caption="Part No" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />

                                        <DxColumn data-field="partSpec" caption="Part Specification" width="15%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="partQty" caption="BOM Qty" width="7%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="partUnitWgt" caption="Unit Weight" width="8%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="whQty" caption="W/H Qty" width="8%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="whDte" caption="W/H Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true"/>

                                        <DxColumn data-field="issDte" caption="Issue Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="psdDt" caption="Material Need Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" header-cell-template="matlNeedDte" />
                                        <template #matlNeedDte>
                                            <div>Material<br />Need Date</div>
                                        </template>

                                        <DxColumn data-field="pipeInproc" caption="IN(S.F.P)" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" />

                                        <DxColumn data-field="pipeOutproc" caption="OUT(S.F.P)" width="7%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="pipeInpaint" caption="IN(P)" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" />
                                        
                                        <DxColumn data-field="pipeOutpaint" caption="OUT(P)" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" />
                                        
                                        <DxColumn data-field="press" caption="S.Test" width="7%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />

                                        <DxColumn data-field="cls" caption="Class" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" />
                                        
                                        <DxColumn data-field="stMakeDte" caption="Make Start" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="edMakeDte" caption="Make Finish" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="stPaintDte" caption="Paint Start" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="edPaintDte" caption="Paint Finish" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="quotNo" caption="Quot No" width="10%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true"/>

                                        <DxColumn data-field="porDt" caption="POR Request Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="delyPlanDte" caption="Delivery Plan Date" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="delyNo" caption="Delivery No" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />

                                        <DxColumn data-field="reqEmp" caption="Requester" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" />      
                                        
                                        <DxColumn data-field="reqIssDte" caption="Req.Iss. Date" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true" />
                                        
                                        <DxColumn data-field="makeLoc" caption="Fab. Loc" width="10%" data-type="string" :allow-editing="false" alignment="center" :visible="true"/>
                                        
                                        <DxColumn data-field="locNop" caption="Pain Loc" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />

                                        <DxColumn data-field="delyLoc" caption="Keep Loc" width="10%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" />                                                                                                                    

                                        <DxPaging :enabled="true" :page-size="30" />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>

                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
        <drawingPagePop v-if="showPop" :showPop.sync="showPop" :gbn="'POR'" :paramNo="dwgPorNo" />
    </v-container>
</template>

<script>
import { DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import drawingPagePop from '@/views/hip/common/drawingPagePop'
import { epms9060List, epms9060Xls } from '@/api/view/hip/91/epms9060.js'
import { getShipNoList1, epms9000_block, epms9000_por_no } from '@/api/view/hip/common/common.js'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import { getNumComma } from '@/utils/common.js'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid } from 'devextreme/excel_exporter'

export default {
    name: 'epms9060',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox,
        drawingPagePop,
        DxExport
    },
    data() {
        return {
            gridMainList: [],
            epms9060Ref: "epms9060Ref",
            epms9060ExclRef : "epms9060ExclRef",
            selectedShip: '',
            shipNoList: [],

            selectedPor: 'All',
            porList: [],
            
            selectedBlock: 'All',
            blockList: [],

            startDate: '',
            endDate: '',

            stDte: '',
            edDte: '',

            vMaker: false,

            dwgPorNo: '',
            showPop: false,
            
            makeSta: {
                select: { name: 'All', cd: 'A' },
                items: [
                    { name: 'All', cd: 'A' },
                    { name: 'Not yet Start', cd: '0' },
                    { name: 'Make Start', cd: '1' },
                    { name: 'Make Finish', cd: '2' },
                    { name: 'Paint Start', cd: '3' },
                    { name: 'Paint Finish', cd: '4' }
                ]
            },

            makeLoc: {
                select: { name: 'All', cd: 'A' },
                items: [
                    { name: 'All', cd: 'A' },
                    { name: 'Van Thai', cd: 'H' },
                    { name: 'Miboo', cd: 'M' },                    
                ]
            },

             durDiv: {
                select: { name: 'By Need Date', cd: '0' },
                items: [
                    { name: 'By Need Date', cd: '0' },
                    { name: 'By Delivery Date', cd: '1' }                  
                ]
            }
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms9060Ref)
        },
        gridMainExclInstance() {
            return this.GetDataGrid(this.epms9060ExclRef)
        },
    },
    methods: {
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },
        formatPrice(value) {           
            return getNumComma(value)
        },
        drawingPage(e) {
            let porNo = e.srcElement.innerText            

            this.dwgPorNo = porNo

            // // console.log('this.dwgPorNo', this.dwgPorNo)

            this.showPop = true
        },
        shipNoChange(e) {

            this.porList = [],
            this.blockList = [],

            this.getPorList()            
            this.getBlockList()

        },
        
        btnRetrieve() {
            if (!this.selectedShip) {
                this.vToastify(this.$t('Ship no is not selected.'), 'warn')
                return
            }

            this.doSearchMain()
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip,
                porNo: this.selectedPor === 'All' ? '' : this.selectedPor,
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                durDiv: this.durDiv.select.cd,
                makeStatus: this.makeSta.select.cd,
                makeLoc: this.makeLoc.select.cd,
                stDte: this.stDte,
                fiDte: this.edDte
            }

            await epms9060List(params).then(res => {
                this.gridMainList = res.list

            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },

        async getShipNoList() {
            let params = {
                makerCd: this.$store.state.user.makerCd
            }

            await getShipNoList1(params).then(res => {
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
            })
        },

        async getPorList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_por_no(params).then(res => {
                this.porList.push('All')
                res.list.forEach(e => {
                    this.porList.push(e.porNo)
                });
            })
        },

        async getBlockList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_block(params).then(res => {
                this.blockList.push('All')
                res.list.forEach(e => {
                    this.blockList.push(e.block)
                });
            })
        },

        onExporting(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Purchase Order List');
        
        exportDataGrid({
            component: this.gridMainExclInstance,
            worksheet,
            topLeftCell: { row: 1, column: 1 },
        }).then((cellRange) => {
            const headerRow = worksheet.getRow(1);
            const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
            const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
            let headerRowLength = headerRow._cells.length
            for(let i = 1; i <= headerRowLength; i++){
            headerRow.getCell(i).fill = headerStyle
            headerRow.getCell(i).border = headerBorderStyle
            headerRow.getCell(i).alignment = { horizontal: 'center' }
            }
            for(let j = 2; j <= worksheet._rows.length; j++){
            for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
                worksheet.getRow(j).getCell(a).border = headerBorderStyle
            }
            }
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DeliveryStatus_' + this.selectedShip + '.xlsx' );
           
            });
        });
        this.gridMainExclInstance.cancel = true;
        
        },

        btnExcel() {
            this.openLoading('Saving Excel!')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip,
                porNo: this.selectedPor === 'All' ? '' : this.selectedPor,
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                durDiv: this.durDiv.select.cd,
                makeStatus: this.makeSta.select.cd,
                makeLoc: this.makeLoc.select.cd,
                stDte: this.stDte,
                fiDte: this.edDte
            }

            epms9060Xls(params).finally(() => {             
                this.endLoading();
            })
            
        },
        //cell merge
        cellPrepared(e) {
            if (e.rowType === 'data') {
                //

            } else {
                if (e.column.caption === 'Part Specification' && e.columnIndex === 3) {                   
                    e.cellElement.setAttribute('colspan', 3)
                } else if (e.column.caption === 'Part Specification' && e.columnIndex === 4) {
                    e.cellElement.style.display = 'none'
                } else if (e.column.caption === 'Part Specification' && e.columnIndex === 5) {
                    e.cellElement.style.display = 'none'
                }
            }
        },
        goGINR() {
            if (!this.selectedShip) {
                this.vToastify(this.$t('Ship no is not selected.'), 'warn')
                return
            }

            let makerCd = this.$store.state.user.makerCd
            let url = "http://dwg.hmd.co.kr/pdfviewer/MIS_DocSearchPor.asp?Ship_Num=" + this.selectedShip + "&Doc_Num=" + this.selectedShip + "GINR&Rev_Num=00&UserID=" + makerCd;
            window.open(url, '_blank', 'popup')
            
        }

        // uppercase() {
        //     this.pntCd = this.pntCd.toUpperCase();
        // }
    },
    mounted() {
        var date = new Date();
        this.startDate = new Date(date.getFullYear(), 0, 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);

        let maker = this.$store.state.user.makerCd
        
        if (maker === '90263' || maker === '11728') {
             this.vMaker = true;
            //console.log("90263")
        } else {
            this.vMaker = false;
            this.makeLoc.select.cd = ''
        };

        this.getShipNoList()
    }
}
</script>

<style scoped>
#epms9060 tr.main-row td {
    font-size: 11px;
    height: 20px;
    border: 1px solid rgb(213, 211, 211);
    border-collapse: collapse;
}

#epms9060 tr.notes-row {
    white-space: normal;
    vertical-align: top;
}

#epms9060 tr.notes-row td {
    font-size: 11px;
    height: 30px;
    border: 1px solid rgb(213, 211, 211);
    border-collapse: collapse;
}

.dark #epms9060 tr.notes-row td {
    color: #777;
}

.v-btn {
    font-size: 11px;
    font-family: 'Roboto', sans-serif;
}
</style>